import { UPDATE_SERVICE, RESET_SERVICE } from "./actionTypes";
import * as Yup from "yup";

const serviceBase = {
    "id": '',
    "internalId": '',
    "description": '',
    "creation_date": '',
    "due_date": '',
    "estimated_cost": '',
    "real_cost": '',
    "status_id": '',
    "status": {
        "id": '',
        "name": '',
        "color": '',
    },
    "supplier_id": '',
    "supplier": {
        "id": '',
        "name": ""
    },
    "trailer_id": '',
    "trailer": {
        "id": '',
        "number": '',
        "name": ''
    },
    "truck_id": '',
    "truck": {
        "id": '',
        "number": '',
        "name": ''
    },
    mileage_control:0,
    current_mileage_truck:0,
    miles_interval_truck:0,
    current_mileage_trailer:0,
    miles_interval_trailer:0
}
const initialState = {
    service: { ...serviceBase },
    validations: {
        internalId: Yup.string().required("Internal ID is required"),
        supplier_id: Yup.string().required("Supplier is required"),
        description: Yup.string().required("Service description is required"),
        estimated_cost: Yup.number()
            .typeError("Estimated cost must be a number")
            .required("Estimated cost is required"),
        creation_date: Yup.date()
            .typeError("Creation date must be a valid date")
            .required("Creation date is required"),
        due_date: Yup.date()
            .typeError("Due date must be a valid date")
            .min(Yup.ref("creation_date"), "Due date must be on or after creation date")
            .required("Due date is required"),
        truck_id: Yup.string().nullable(),
        trailer_id: Yup.string().nullable(),
    }
};

const serviceOrder = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SERVICE:
            // Actualizar el estado
            return  {
                ...state,
                service: action.payload
            };
        case RESET_SERVICE:
            return {
                ...state,
                service: { ...serviceBase }
            };
        default:
            return state;
    }
};

export default serviceOrder;
